import React from "react";
import { useTranslation } from "react-i18next";

import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { useDeletePhotoGallerySectionMutation } from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

interface DeleteSectionGalleryProps {
  reFetch: () => void;
}

const DeleteSectionGallery = ({ reFetch }: DeleteSectionGalleryProps) => {
  const { t } = useTranslation();
  const { openModal, currentId } = useURLParamsGetter<{
    openModal: string;
    currentId: string;
  }>();
  const setParams = useURLParamsSetter(true);
  const { notifySuccess } = useNotify();

  const [deleteSectionGallery] = useDeletePhotoGallerySectionMutation({
    onCompleted: () => {
      reFetch();
      notifySuccess(t("photoGallery.removeSection"));
      closeModal();
    },
  });

  const closeModal = () =>
    setParams({ openModal: undefined, currentId: undefined });

  const removeHandle = () => {
    deleteSectionGallery({
      variables: { deletePhotoGallerySectionId: currentId },
    });
  };

  return (
    <ConfirmModal
      open={openModal === "Sure"}
      text={t("photoGallery.remove")}
      onConfirm={removeHandle}
      onCancel={closeModal}
    />
  );
};

export default DeleteSectionGallery;
